<template>
  <side-menu-item
    :classes="option.classes"
    :active="isExactActiveIncludingQuery"
  >
    <template v-slot:icon>
      <icon-base
        class="-mt-1 place-self-center text-primary"
        :height="option.height || '16'"
        :width="option.width || '16'"
        :view-box="option.viewBox || '0 0 16 16'"
        :icon="option.icon"
        :icon-name="option.label"
        :icon-color="option.iconColor ?? 'none'"
      />
    </template>
    <span>{{ option.label }}</span>
    <experimental-tag
      v-if="option.new || option.beta"
      :type="option.beta ? 'beta' : 'new'"
    />
  </side-menu-item>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import ExperimentalTag from "../ui/ExperimentalTag.vue";
import SideMenuItem from "@/components/ui/SideMenuItem.vue";

import type { ISidebarSubmenuOption } from "@/models/common";

const { active, option } = defineProps<{
  active?: boolean;
  option: ISidebarSubmenuOption;
}>();

const route = useRoute();

const isExactActiveIncludingQuery = computed(() => {
  if (!active) {
    return false;
  }
  if (typeof option.link === "string" || !option.link?.query) {
    return active;
  }
  return JSON.stringify(option.link.query) === JSON.stringify(route.query);
});
</script>
